export const DESKTOP_CARD_WIDTH = 250
export const DESKTOP_CARD_HEIGHT = 400

const ASPECT_RATIO = DESKTOP_CARD_HEIGHT / DESKTOP_CARD_WIDTH // 1.6

export const getCardDimensions = (
  contentWidth: number,
  isMobile: boolean,
  availableHeight?: number,
): { width: number; height: number } => {
  if (!isMobile) {
    return { width: DESKTOP_CARD_WIDTH, height: DESKTOP_CARD_HEIGHT }
  }
  const widthConstrained = { width: contentWidth, height: contentWidth * ASPECT_RATIO }
  if (availableHeight != null && widthConstrained.height > availableHeight) {
    return { width: availableHeight / ASPECT_RATIO, height: availableHeight }
  }
  return widthConstrained
}
